// shopifyLoader.js
let scriptLoaded = false;
let loadPromise;

export function ShopifyLoader() {
    if (scriptLoaded && window.ShopifyBuy && window.ShopifyBuy.UI) {
        return Promise.resolve();
    }

    if (!loadPromise) {
        loadPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
            script.async = true;
            script.onload = () => {
                if (window.ShopifyBuy && window.ShopifyBuy.UI) {
                    scriptLoaded = true;
                    resolve();
                } else {
                    reject(new Error('ShopifyBuy SDK failed to load.'));
                }
            };
            script.onerror = reject;
            document.body.appendChild(script);
        });
    }

    return loadPromise;
}
